export function MinutesTo12HourFormat(minutes) {
    var hours = Math.floor(minutes / 60);
    var minutesRemaining = minutes % 60;

    // Convert hours to 12-hour format
    if (hours === 0) {
        hours = 12;
    } else if (hours > 12) {
        hours -= 12;
    }

    // Pad single digit minutes with leading zero
    var minutesString = minutesRemaining < 10 ? "0" + minutesRemaining : minutesRemaining;

    return hours + " h : " + minutesString + " m";
};